<template>
  <StackLayout class="head">
    <AgModeBanner v-if="showModeBanner && !reducedModeBanner" />
    <FlexboxLayout class="main" justifyContent="space-between" alignItems="center">
      <FlexboxLayout>
        <AgIcon v-if="back" class="back" type="fas:chevronLeft" color="white" @tap="goBack" @click="goBack" justifyContent="flex-start" />
        <StackLayout>
          <h1 class="text">{{ text }}</h1>
          <Label v-if="subtext" class="subtext" :text="subtext" textWrap />
        </StackLayout>
      </FlexboxLayout>
      <FlexboxLayout alignItems="center">
        <AgModeBanner reduced v-if="showModeBanner && reducedModeBanner" />
        <AgUser v-if="isActive" />
      </FlexboxLayout>
    </FlexboxLayout>
  </StackLayout>
</template>
<script>

export default {
  components: {
    AgUser: () => import('@/components/User'),
    AgModeBanner: () => import('@/components/ModeBanner'),
  },
  props: {
    text: {
      type: String,
      default: '[text]'
    },
    subtext: {
      type: String,
      default: ''
    },
    back: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isActive () {
      return !this.$store.state.settings.id || this.$store.state.settings.status
    },
    showModeBanner () {
      return this.$store.state.apiMode !== 'prd'
    },
    reducedModeBanner () {
      return this.$store.state.modeBanner
    },
  },
  methods: {
    goBack () {
      this.$emit('back')
    }
  }
}

</script>

<style scoped lang="scss">

.main {
  border-bottom-color: rgba(255, 255, 255, 0.2);
}

.head .text {
  font-family: 'Inter', 'RobotoCondensed-Regular', 'Roboto Condensed';
  color: #FFFFFF;
  margin: 0;
  padding: 0;
  font-weight: normal;
}

.head .subtext {
  margin-top: 3px;
  font-family: 'Inter', 'RobotoCondensed-Regular', 'Roboto Condensed';
  font-size: 13px;
  color: #FFFFFF;
}

.ns-ios,
.ns-android {
  .main {
    border-bottom-width: 1;
    padding: 20 0;
  }

  .head .text {
    font-size: 23;
    margin: 0;
    padding: 0;
    font-weight: normal;
  }

  .ns-ios .head .text {
    font-size: 26;
    margin: 0;
    padding: 0;
    font-weight: normal;
  }

  .back {
    width: 30;
  }

  .mode-banner.reduced {
    margin-right: 20;
  }
}

html {
  .main {
    border-bottom-style: solid;
    border-bottom-width: 1px;
    padding: 20px 0;
  }

  .head .text {
    font-size: 26px;
    margin: 0;
    padding: 0;
    font-weight: normal;
  }

  .back {
    width: 30px;
    cursor: pointer;
  }

  @media (min-width: 800px) {
    .main {
      padding-top: 40px;
      padding-bottom: 40px;
    }
  }

  .mode-banner.reduced {
    margin-right: 20px;
  }
}

</style>
